export interface RecalProcessAndGenSearchCriteria {

    groupNo: number | null,
    seqNo: number | null,
    billToCompany: string | null,
    customerCode: string | null,
    chargeType: string | null,
    subChargeType: string | null,
    tarType: string | null,
    tarCode: string | null,
    opsDateFrom: Date | null,
    opsDateTo: Date | null,
    depDateFrom: Date | null,
    depDateTo: Date | null,
    docDateFrom: Date | null,
    docDateTo: Date | null,
    docNoFrom: string | null,
    docNoTo: string | null,
    state: string | null,
    ntnNo: string | null,
    co: string | null,
    vsl: string | null,
    voy: string | null,

    [key: string]: string[] | string | boolean | number | Date | null | undefined
}

export const EMPTY_RECAL_PROCESS_AND_GEN_SEARCH_CRITERIA: RecalProcessAndGenSearchCriteria = {
    groupNo: null,
    seqNo: null,
    billToCompany: null,
    customerCode: null,
    chargeType: null,
    subChargeType: null,
    tarType: null,
    tarCode: null,
    opsDateFrom: null,
    opsDateTo: null,
    depDateFrom: null,
    depDateTo: null,
    docDateFrom: null,
    docDateTo: null,
    docNoFrom: null,
    docNoTo: null,
    state: null,
    ntnNo: null,
    co: null,
    vsl: null,
    voy: null
}